function readRuntimeConfig() {
  if (typeof window === 'undefined') return {};
  return window.__ONECLOUD_ADMIN_CONFIG__ || {};
}

export function getAppConfig(name) {
  const value = readRuntimeConfig()[name];
  if (typeof value === 'string' && value.trim()) return value;
  return process.env[name] || '';
}
